import { cn } from '@/lib/utils';

/**
 * Sprint 5b.1.6 C.3 (amendement D.3) — liste des contraintes textuelles libres
 * détectées par l'IA (`otherConstraints`).
 *
 * Affichage discret : puces grisées sous les badges, max 3 + « +N autres »
 * si la liste contient plus. Pas de filtrage dur dessus en V1.
 */

interface OtherConstraintsListProps {
  constraints: string[];
  className?: string;
  maxVisible?: number;
}

export function OtherConstraintsList({
  constraints,
  className,
  maxVisible = 3,
}: OtherConstraintsListProps) {
  if (!constraints || constraints.length === 0) return null;

  const visible = constraints.slice(0, maxVisible);
  const remaining = constraints.length - visible.length;

  return (
    <ul className={cn('text-xs text-muted-foreground space-y-0.5', className)}>
      {visible.map((c, i) => (
        <li key={`${i}-${c}`} className="leading-snug">
          • {c}
        </li>
      ))}
      {remaining > 0 && (
        <li className="leading-snug italic">+{remaining} autre{remaining > 1 ? 's' : ''}</li>
      )}
    </ul>
  );
}
